export   function scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth', // défilement fluide
        block: 'start'    // aligné en haut de la page
      });
    } else {
      console.warn(`Élément avec id "${elementId}" introuvable.`);
    }
  }


export const animateScroll =()=>{
    // Calcule la position actuelle de défilement
    var scrollStep = window.pageYOffset / 15;

    // Si nous ne sommes pas encore au sommet, continue à faire défiler
    if (window.pageYOffset > 0) {
      window.scrollBy(0, -scrollStep);
      requestAnimationFrame(animateScroll);
    } else {
      // Une fois que nous sommes arrivés au sommet, arrête l'animation
      cancelAnimationFrame(animateScroll);
    }
  }
 

export function fmtAmount(value) {
  const n = parseFloat(value || 0);
  if (n === 0) return "0";

  // 1. On stocke le signe et on travaille en valeur absolue
  const isNegative = n < 0;
  const absN = Math.abs(n);
  
  let formatted = "";

  // 2. On applique les règles de formatage avec un max de 6 décimales
  if (absN >= 1000)        formatted = `${(absN / 1000).toFixed(1)}K`;
  else if (absN >= 100)    formatted = absN.toFixed(0);
  else if (absN >= 10)     formatted = absN.toFixed(1);
  else if (absN >= 1)      formatted = absN.toFixed(2);
  else if (absN >= 0.01)   formatted = absN.toFixed(3);
  else if (absN >= 0.0001) formatted = absN.toFixed(5);
  else                     formatted = absN.toFixed(6); // Limite stricte à 6 décimales pour le reste

  // 3. On ajoute le signe "-" si nécessaire
  return isNegative ? `-${formatted}` : formatted;
}